import { Component } from "react";
import { trackConversionEvent } from "../core/analytics/conversionAnalytics";
import styles from "./RootErrorBoundary.module.css";

export default class RootErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Never send the message, stack, URL or user data to Analytics: a render
    // error can contain private content from the component that failed.
    const safeErrorType = ["TypeError", "ReferenceError", "RangeError", "SyntaxError"]
      .includes(error?.name) ? error.name : "Error";
    trackConversionEvent("app_render_error", {
      boundary: "root",
      error_type: safeErrorType,
    });
    console.error("Application rendering failed", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className={styles.root} role="alert">
        <section className={styles.card}>
          <span className={styles.eyebrow}>KARANGO</span>
          <h1 className={styles.title}>Impossible d’afficher cet écran</h1>
          <p className={styles.description}>
            Une erreur inattendue s’est produite. Recharge la page pour reprendre.
          </p>
          <button
            className={styles.button}
            type="button"
            onClick={() => window.location.reload()}
          >
            Recharger l’application
          </button>
        </section>
      </main>
    );
  }
}
